import React, { ChangeEvent, useState } from "react";
import styles from "./article-language-picker.module.scss";
import { useRouter } from "next/router";
import { LanguageKeyValues } from "@hub/data/values/language-key.values";
import { LanguageMetadataModel } from "@hub/models/metadata/language-metadata.model";

interface DataPickerProps {
  name: string;
  label: string;
  languageMetadata?: LanguageMetadataModel | null;
  disabled?: boolean;
}

export const ArticleLanguagePicker: React.FC<DataPickerProps> = (props) => {
  const { label, name, languageMetadata, disabled = false } = props;

  const router = useRouter();
  const [language, setLanguage] = useState<LanguageKeyValues | null>(
    languageMetadata ? languageMetadata.defaultLocale : null,
  );

  const handleLanguageChange = async (e: ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;

    setLanguage(value as LanguageKeyValues);

    if (languageMetadata) {
      const locale = languageMetadata.locales[value];

      if (locale && locale.path) {
        await router.push(locale.path);
      }
    }
  };

  if (!(languageMetadata && language)) {
    return null;
  }

  const { options } = languageMetadata;

  let containerClassName = styles.field;

  if (disabled) {
    containerClassName += ` ${styles.disabled}`;
  }

  return (
    <>
      <div
        data-heap-redact-text="true"
        heap-ignore="true"
        className={containerClassName}
      >
        <div className={styles.icon}>
          <svg
            width="16"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="bie152-25 laIDRx"
          >
            <g
              clipPath="url(#language-icon_svg__clip0_1203_16945)"
              stroke="#b1b7c2"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3.333 5.333l4 4M2.667 9.333l4-4 1.333-2M1.333 3.333h8M4.667 1.333h.666M14.667 14.667L11.333 8 8 14.667M9.333 12h4"></path>
            </g>
            <defs>
              <clipPath id="language-icon_svg__clip0_1203_16945">
                <path fill="#fff" d="M0 0h16v16H0z"></path>
              </clipPath>
            </defs>
          </svg>
        </div>
        <select
          aria-label={label}
          data-heap-redact-text="true"
          heap-ignore="true"
          disabled={disabled || options.length < 2}
          id={name}
          data-qa-input={name}
          className={styles.input}
          value={language}
          onChange={handleLanguageChange}
        >
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              className={styles.option}
            >
              {option.label}
            </option>
          ))}
        </select>
        <div aria-hidden={true} className={styles.arrow}>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.8001 12.9394L16.2698 7.46973L17.3304 8.53039L11.3304 14.5304C11.0376 14.8233 10.5627 14.8233 10.2698 14.5304L4.26978 8.53039L5.33044 7.46973L10.8001 12.9394Z"
              fill="#b1b7c2"
            />
          </svg>
        </div>
      </div>
    </>
  );
};
